import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const LibraryIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '19',
    height: props.height || '21',
    fill: props.fill || '#43494F',
  };
  return (
    <svg viewBox='0 0 19 21' {...svgProps} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.5 21H0.75V2.625C0.75 1.17775 1.92775 0 3.375 0H11.6875C15.3065 0 18.25 2.9435 18.25 6.5625C18.25 10.1815 15.3065 13.125 11.6875 13.125H2.5V21ZM2.5 11.375H11.6875C14.3414 11.375 16.5 9.2155 16.5 6.5625C16.5 3.9095 14.3414 1.75 11.6875 1.75H3.375C2.89287 1.75 2.5 2.142 2.5 2.625V11.375Z'
        fill={svgProps.fill}
      />
    </svg>
  );
};

LibraryIcon.iconType = ICON_TYPES.LIBRARY_ICON;

export default LibraryIcon;
